// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f2fadf89","516":"b5aa9471","675":"7321b3f4","711":"663f663a"}[chunkId] + ".chunk.js";
};